/* Revelation Table theme — vanilla JS, no dependencies */
(function(){
  'use strict';
  var RT=window.RT||{routes:{},strings:{}};
  var body=document.body,lastFocus=null;
  function $(s,c){return (c||document).querySelector(s)}
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;')}

  /* header: collapse the announcement line once the page scrolls */
  var hdr=$('#hdr');
  function onScroll(){if(hdr)hdr.classList.toggle('solid',(window.scrollY||0)>40)}
  window.addEventListener('scroll',function(){window.requestAnimationFrame(onScroll)},{passive:true});onScroll();

  /* overlays */
  var IDS={cart:'cart',search:'search',menu:'menu'};
  function setO(name,on,focusEl){
    var el=document.getElementById(IDS[name]);if(!el)return;
    body.classList.toggle('o-'+name,on);
    el.setAttribute('aria-hidden',on?'false':'true');
    var mb=$('#menuBtn');if(name==='menu'&&mb)mb.setAttribute('aria-expanded',on?'true':'false');
    if(on){lastFocus=document.activeElement;setTimeout(function(){var t=focusEl||el.querySelector('button,input,a');if(t&&t.focus)t.focus()},60)}
    else if(lastFocus&&lastFocus.focus){lastFocus.focus()}
  }
  function closeAll(){['cart','search','menu'].forEach(function(n){if(body.classList.contains('o-'+n))setO(n,false)});closeLb()}
  document.addEventListener('click',function(e){
    var t;
    if((t=e.target.closest('[data-open]'))){
      var n=t.getAttribute('data-open');
      if(n==='cart'&&body.classList.contains('template-cart'))return;
      e.preventDefault();
      if(n!=='menu'&&body.classList.contains('o-menu')){body.classList.remove('o-menu');var m0=$('#menu');if(m0)m0.setAttribute('aria-hidden','true')}
      if(n==='menu'&&body.classList.contains('o-menu')){setO('menu',false);return}
      setO(n,true,n==='search'?$('#sInput'):null);return;
    }
    if(e.target.closest('[data-close]')||e.target.id==='scrim'){closeAll();return}
    if(e.target.closest('[data-close-menu]')){body.classList.remove('o-menu');var m=$('#menu');if(m)m.setAttribute('aria-hidden','true');return}
    if((t=e.target.closest('.mrow'))){var o=t.getAttribute('aria-expanded')==='true';t.setAttribute('aria-expanded',o?'false':'true');var sub=document.getElementById(t.getAttribute('aria-controls'));if(sub)sub.classList.toggle('on',!o);return}
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape')closeAll();
    var lb=$('#lb');
    if(lb&&lb.classList.contains('on')){if(e.key==='ArrowRight')stepLb(1);if(e.key==='ArrowLeft')stepLb(-1)}
  });

  /* toast */
  var tt;function toast(m){var t=$('#toast');if(!t)return;t.textContent=m;t.classList.add('on');clearTimeout(tt);tt=setTimeout(function(){t.classList.remove('on')},2400)}

  /* cart drawer (Section Rendering API) */
  function refreshDrawer(open){
    return fetch(RT.routes.root+'?sections=cart-drawer',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json()})
      .then(function(j){
        var doc=new DOMParser().parseFromString(j['cart-drawer'],'text/html');
        var inner=doc.querySelector('.js-drawer-inner'),cur=$('.js-drawer-inner');
        if(inner&&cur){cur.innerHTML=inner.innerHTML;var c=parseInt(inner.getAttribute('data-count')||'0',10);setCount(c)}
        if(open)setO('cart',true);
      }).catch(function(){window.location.href=RT.routes.cart});
  }
  function setCount(c){var b=$('#cartCount');if(!b)return;b.textContent=c;b.classList.toggle('on',c>0)}
  document.addEventListener('submit',function(e){
    var f=e.target.closest('form.js-add');if(!f)return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]');if(btn&&btn.disabled)return;
    if(btn){btn.disabled=true;btn.dataset.t=btn.textContent;btn.textContent=RT.strings.adding||'Adding…'}
    fetch(RT.routes.cartAdd,{method:'POST',body:new FormData(f),headers:{'Accept':'application/json'}})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){var m=f.querySelector('.pdp-msg');var msg=res.j.description||res.j.message||'Could not add this item.';if(m)m.textContent=msg;else toast(msg);return}
        var m2=f.querySelector('.pdp-msg');if(m2)m2.textContent='';
        return refreshDrawer(true);
      })
      .catch(function(){f.submit()})
      .then(function(){if(btn){btn.disabled=false;btn.textContent=btn.dataset.t}});
  });
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-line]');if(!t)return;
    e.preventDefault();
    var line=parseInt(t.getAttribute('data-line'),10),q=parseInt(t.getAttribute('data-qty'),10);
    fetch(RT.routes.cartChange,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:Math.max(0,q)})})
      .then(function(){return refreshDrawer(false)});
  });

  /* variant select updates the displayed price and button */
  var vs=$('#variantSelect');
  if(vs){
    var pr=$('#pdpPrice'),ab=$('#pdpAdd');
    vs.addEventListener('change',function(){
      var o=vs.options[vs.selectedIndex];
      if(pr&&o.dataset.price)pr.innerHTML=o.dataset.price;
      if(ab){ab.disabled=o.dataset.avail!=='true';ab.textContent=o.dataset.avail==='true'?(RT.strings.add||'Add to bag'):(RT.strings.soldOut||'Sold out')}
    });
  }

  /* best sellers: tabs + rail arrows */
  var tabs=$('#tabs'),rail=$('#rail');
  if(tabs&&rail){
    tabs.addEventListener('click',function(e){
      var b=e.target.closest('[data-filter]');if(!b)return;
      $$('button',tabs).forEach(function(x){x.setAttribute('aria-selected',x===b?'true':'false')});
      var k=(b.getAttribute('data-filter')||'').toLowerCase();
      $$('.pc',rail).forEach(function(c){c.hidden=!!k&&(c.getAttribute('data-title')||'').indexOf(k)<0});
      rail.scrollLeft=0;
    });
    var step=function(d){rail.scrollBy({left:d*rail.clientWidth*.8,behavior:'smooth'})};
    var p=$('#rP'),n=$('#rN');if(p)p.onclick=function(){step(-1)};if(n)n.onclick=function(){step(1)};
  }

  /* story video */
  var vb=$('.vplay');
  if(vb){vb.addEventListener('click',function(){
    var box=vb.closest('.sp-img'),v=$('video',box),p=$('.vposter',box),c=$('.vcap',box);
    if(!v)return;v.hidden=false;v.controls=true;if(p)p.style.display='none';vb.style.display='none';if(c)c.style.display='none';
    var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});
  })}

  /* gallery lightbox */
  var gal=$('#gal'),lb=$('#lb'),li=0,items=gal?$$('.gi',gal):[];
  function showLb(i){li=(i+items.length)%items.length;var it=items[li];$('#lbFrame').innerHTML='<img src="'+esc(it.getAttribute('data-full'))+'" alt="'+esc(it.getAttribute('data-cap')||'')+'" class="'+(it.getAttribute('data-ph')==='1'?'ph':'')+'">';$('#lbCap').textContent=it.getAttribute('data-cap')||''}
  function openLb(i){if(!lb)return;lastFocus=document.activeElement;showLb(i);lb.classList.add('on');$('#lbClose').focus()}
  function closeLb(){if(lb&&lb.classList.contains('on')){lb.classList.remove('on');if(lastFocus&&lastFocus.focus)lastFocus.focus()}}
  function stepLb(d){showLb(li+d)}
  window.closeLb=closeLb;
  if(gal){gal.addEventListener('click',function(e){var b=e.target.closest('.gi');if(b)openLb(items.indexOf(b))})}
  if(lb){$('#lbClose').onclick=closeLb;$('#lbPrev').onclick=function(){stepLb(-1)};$('#lbNext').onclick=function(){stepLb(1)};lb.addEventListener('click',function(e){if(e.target===lb)closeLb()})}

  /* predictive search */
  var si=$('#sInput'),sr=$('#sRes'),st;
  function money(v){try{return new Intl.NumberFormat(undefined,{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(parseFloat(v))}catch(e){return v}}
  if(si&&sr){si.addEventListener('input',function(){
    clearTimeout(st);var q=si.value.trim();
    if(q.length<2){sr.innerHTML='';return}
    st=setTimeout(function(){
      fetch(RT.routes.predictive+'.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6',{headers:{'Accept':'application/json'}})
        .then(function(r){return r.json()})
        .then(function(j){
          var list=(j.resources&&j.resources.results&&j.resources.results.products)||[];
          sr.innerHTML=list.length?list.map(function(p){return '<a class="sr" href="'+esc(p.url)+'"><h3>'+esc(p.title)+'</h3><span class="pr">'+esc(money(p.price))+'</span></a>'}).join('')+'<p style="margin-top:1rem"><a class="ulink" href="'+RT.routes.search+'?q='+encodeURIComponent(q)+'">'+(RT.strings.viewAll||'View all results')+'</a></p>':'<p class="empty">'+(RT.strings.noResults||'No results found.')+'</p>';
        }).catch(function(){});
    },250);
  })}
})();
